import * as Xstate from "@xstate/react";
import React from "react";

import { GlobalContext } from "../../app/stateMachines/GlobalContext";
import { LottieLoading } from "../../components/graphics/LottieLoading";
import { OnboardingView } from "../onboarding/OnboardingView";
import { TwoStepGate } from "../twoStep/TwoStepGate";
import { MainView } from "./MainView";
import { UserAuthLoadingMainView } from "./UserAuthLoadingMainView";
import { UserInfoLoadingMainView } from "./UserInfoLoadingMainView";

export const LoadingMainView: React.FC<unknown> = () => {
  const { userAuthService, userInfoService, onboardingInfoService } =
    React.useContext(GlobalContext);
  const isUserAuthEmptyState = Xstate.useSelector(
    userAuthService,
    (state) => state.context.userAuthInfo === undefined,
  );
  const signedInEmail = Xstate.useSelector(
    userAuthService,
    (state) => state.context.userAuthInfo?.email || "",
  );
  const isUserInfoEmptyState = Xstate.useSelector(
    userInfoService,
    (state) => state.context.userInfoByEmail === undefined,
  );
  const isOnboardingIncompleteState = Xstate.useSelector(
    onboardingInfoService,
    (state) => {
      const { onboardingStatus } = state.context;
      return (
        onboardingStatus === undefined ||
        !onboardingStatus.orgIsOnboarded ||
        !onboardingStatus.userIsOnboarded
      );
    },
  );

  if (isUserAuthEmptyState) {
    return (
      <div>
        <UserAuthLoadingMainView />
        <LottieLoading />
      </div>
    );
  }

  // Two-step sign-in (Roadmap 1845): after the Microsoft sign-in and before
  // anything else is loaded. No change for people without it.
  return (
    <TwoStepGate email={signedInEmail}>
      {isUserInfoEmptyState ? (
        <div>
          <UserInfoLoadingMainView />
          <LottieLoading />
        </div>
      ) : isOnboardingIncompleteState ? (
        <div>
          <OnboardingView />
        </div>
      ) : (
        <>
          <UserAuthLoadingMainView />
          <MainView />
        </>
      )}
    </TwoStepGate>
  );
};
